import { type UserInfo } from "helpers/AppProvider.types";

import { CommonConstants } from "types/constants";

export function isOrgOwner(userInfo: UserInfo | undefined) {
    if (!userInfo?.roleInfo) {
        return false;
    }

    return (
        userInfo.roleInfo.roleIsSystemDefault &&
        userInfo.roleInfo.roleName === CommonConstants.OrgOwnerRoleName
    );
}
